import gsap from "gsap";

const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

// shared page chrome: custom cursor, magnetic elements, sydney clock
export function initCursor() {
  if (!finePointer) return;
  document.body.classList.add("has-cursor");
  const cursor = document.querySelector(".cursor");
  const dot = cursor.querySelector(".cursor__dot");
  const ring = cursor.querySelector(".cursor__ring");

  const dotX = gsap.quickTo(dot, "x", { duration: 0.08, ease: "power2.out" });
  const dotY = gsap.quickTo(dot, "y", { duration: 0.08, ease: "power2.out" });
  const ringX = gsap.quickTo(ring, "x", { duration: 0.35, ease: "power3.out" });
  const ringY = gsap.quickTo(ring, "y", { duration: 0.35, ease: "power3.out" });

  window.addEventListener(
    "pointermove",
    (e) => {
      dotX(e.clientX);
      dotY(e.clientY);
      ringX(e.clientX);
      ringY(e.clientY);
    },
    { passive: true }
  );

  document.querySelectorAll("[data-cursor='view']").forEach((el) => {
    el.addEventListener("pointerenter", () => cursor.classList.add("is-view"));
    el.addEventListener("pointerleave", () => cursor.classList.remove("is-view"));
  });
}

export function initMagnetic() {
  if (!finePointer || reduced) return;
  document.querySelectorAll("[data-magnetic]").forEach((el) => {
    const xTo = gsap.quickTo(el, "x", { duration: 0.4, ease: "power3.out" });
    const yTo = gsap.quickTo(el, "y", { duration: 0.4, ease: "power3.out" });

    el.addEventListener("pointermove", (e) => {
      const r = el.getBoundingClientRect();
      xTo((e.clientX - (r.left + r.width / 2)) * 0.25);
      yTo((e.clientY - (r.top + r.height / 2)) * 0.25);
    });
    el.addEventListener("pointerleave", () => {
      xTo(0);
      yTo(0);
    });
  });
}

export function initClock() {
  const els = document.querySelectorAll("[data-clock]");
  function tick() {
    const t = new Date().toLocaleTimeString("en-AU", {
      timeZone: "Australia/Sydney",
      hour12: false,
    });
    els.forEach((el) => (el.textContent = t));
  }
  tick();
  setInterval(tick, 1000);
}
